import { TabbedContents } from "../../../ui/containers/TabbedContent";
import { ComponentF, createElement } from "../../../ui/ui";
import { EquipmentPanel } from "../info/EquipmentPanel";
import { ContainsPanel } from "./ContainsPanel";
import { InventoryControls } from "./InventoryControls";

export const InventoryPanel: ComponentF<void> = (C) => {
  const tabbedHeight = C.bounds.h - 8;
  return [
    createElement(
      TabbedContents,
      { x: 0, y: 0, w: C.bounds.w, h: tabbedHeight },
      {
        children: [
          {
            keys: ["E", "e"],
            title: "quip",
            value: createElement(EquipmentPanel, {
              x: 0,
              y: 0,
              w: C.bounds.w,
              h: tabbedHeight - 1,
            }),
          },
          {
            keys: ["I", "i"],
            title: "nventory",
            value: createElement(ContainsPanel, {
              x: 0,
              y: 0,
              w: C.bounds.w,
              h: tabbedHeight - 1,
            }),
          },
        ],
      }
    ),
    createElement(InventoryControls, {
      x: 0,
      y: tabbedHeight + 1,
      w: C.bounds.w,
      h: C.bounds.h - tabbedHeight,
    }),
  ];
};
